import { Http } from "@repo/http"

const http = new Http()
http.setDefaultConfig({
  baseURL: process.env.NEXT_PUBLIC_API_HOST_EN,
  timeout: 10000,
  getToken: async () => {
    if (typeof window === "undefined") {
      const { cookies } = await import("next/headers")
      const cookieStore = await cookies()
      if (!process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY) {
        return ""
      }
      const token = cookieStore.get(process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY)?.value || ""
      return token
    }
  },
  getLang: async () => {
    if (typeof window === "undefined") {
      try {
        const { getLocale } = await import("next-intl/server")
        return await getLocale()
      } catch {
        return "en"
      }
    }
  },
  log: {
    enable: false,
  },
})

http.addErrorInterceptor(async (error) => {
  return true
})

export default http
